import { cx } from "@suse-o11y/class-variance";
import { format } from "@suse-o11y/date-time";
import type { Time } from "@suse-o11y/date-time/time";
import React from "react";

export const MessageTimestamp: React.FC<{ createdAt: Time; className?: string }> = ({ createdAt, className }) => (
	<span className={cx("mt-1 block text-11 text-grey-700", className)}>{format(createdAt, "HH:mm")}</span>
);
